/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages } from '@nebula/izzy/intl';
import Copy from '@nebula/luna/dist/core/copy';
import { DevicePicker } from '@quarry-connected/assurance-device-picker';

import styles from './styles/connect.content.styl';

const MSG = defineMessages({
  connected: {
    id: 'gemini.session.create.devices.connected',
    defaultMessage: 'You are now connected to the session.'
  },
  connecting: {
    id: 'gemini.session.create.devices.connecting',
    defaultMessage: 'Waiting on the device to send events to the session.'
  },
  description: {
    id: 'gemini.session.create.devices.description',
    defaultMessage: 'Open your app and shake the device. Then find your device in the list below and click connect.'
  }
});

const SessionCreateQuickConnectContent = ({
  connecting,
  image,
  izzy,
  stepIndex,
  ...props
}) => (
  <div
    data-omega-element="quick connect"
    data-omega-widget="quick connect"
    data-omega-widget-type="modal"
  >
    {stepIndex === 1 ? (
      <div>
        <Copy className={styles.description}>
          {izzy(MSG.description)}
        </Copy>
        <DevicePicker
          locale="en"
          onConnectPress={() => {}}
          {...props}
        />
      </div>
    ) : (
      <div>
        <Copy className={styles.description}>
          {connecting ? izzy(MSG.connecting) : izzy(MSG.connected)}
        </Copy>
        <div className={styles.image}>
          <img alt="" src={image} />
        </div>
      </div>
    )}
  </div>
);

SessionCreateQuickConnectContent.displayName = 'SessionCreateQuickConnectContent';
export default SessionCreateQuickConnectContent;
